var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShop = function SvgShop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249,
    height: 294,
    fill: "none",
    viewBox: "0 0 249 294"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M219.716 175.036v88.34l-191.954-.029-.399-88.311M4.566 126.591l22.798-66.967h193.778l25.647 66.967"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M61.218 126.592c-.613 17.083-14.648 30.719-31.874 30.719s-31.275-13.636-31.888-30.719zM125.334 126.592c-.613 17.083-14.647 30.719-31.874 30.719s-31.26-13.636-31.873-30.719h63.761zM189.452 126.592c-.612 17.083-14.647 30.719-31.873 30.719-17.227 0-31.261-13.636-31.874-30.719h63.762zM253.569 126.592c-.612 17.083-14.647 30.719-31.873 30.719s-31.261-13.636-31.874-30.719h63.762zM195.495 239.154v-32.059c0-17.706-14.354-32.059-32.059-32.059-17.706 0-32.059 14.353-32.059 32.059v32.059zM88.203 212.837l17.925-4.973c1.268-.356 1.282-2.151 0-2.522l-17.868-5.143a1.32 1.32 0 0 1-.897-.912l-4.973-17.925c-.356-1.268-2.151-1.282-2.522 0l-5.144 17.868c-.128.441-.47.769-.912.897L55.889 205.1c-1.268.356-1.282 2.151 0 2.522l17.868 5.144c.441.128.769.47.897.911l4.973 17.925c.356 1.268 2.151 1.282 2.522 0l5.144-17.868c.128-.441.47-.769.911-.897"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h249v294H0z"
  })))));
};
export default SvgShop;